export default "__VITE_ASSET__7IF9zXp7__ 500w";